const baseUrl = process.env.VUE_APP_SERVER_URL || 'http://localhost:5000';
export default baseUrl;
